/*
 * Module for the Insurance Coverage Change job criteria page
 */
rs.module("content/jobs/criteria/insurancecoveragechange",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the page
        function initialize(jsSelectors, cssSelectors, backendUrls) {

            var criteria = $.js(jsSelectors.criteria);
       
            var insuranceTypeSelect = criteria.js(jsSelectors.insuranceTypeSelect);
            var insuranceCarrierSelect = criteria.js(jsSelectors.insuranceCarrierSelect);
            var insuranceRateTierSelect = criteria.js(jsSelectors.insuranceRateTierSelect);
            var terminatingInsuranceCoverageSelect = criteria.js(jsSelectors.terminatingInsuranceCoverageSelect);
            var terminatingInsuranceCoverageCostContainer = criteria.js(jsSelectors.terminatingInsuranceCoverageCostContainer);
            var terminatingInsuranceCoverageCostPanel = criteria.js(jsSelectors.terminatingInsuranceCoverageCostPanel);
            var terminatingInsuranceCoverageCostItem = criteria.js(jsSelectors.terminatingInsuranceCoverageCostItem, { multiple: true });
            var terminatingInsuranceCoverageCostEmpty = criteria.js(jsSelectors.terminatingInsuranceCoverageCostEmpty);
            var terminatingInsuranceCoverageTotalCostValue = criteria.js(jsSelectors.terminatingInsuranceCoverageTotalCostValue);
            var terminatingInsuranceCoverageSubsidyAmountValue = criteria.js(jsSelectors.terminatingInsuranceCoverageSubsidyAmountValue);
            var replacementInsuranceCoverageEffectiveDatePicker = criteria.js(jsSelectors.replacementInsuranceCoverageEffectiveDatePicker);
            var replacementInsuranceCoverageSelect = criteria.js(jsSelectors.replacementInsuranceCoverageSelect);
            var replacementInsuranceCoverageCostContainer = criteria.js(jsSelectors.replacementInsuranceCoverageCostContainer);
            var replacementInsuranceCoverageCostPanel = criteria.js(jsSelectors.replacementInsuranceCoverageCostPanel);
            var replacementInsuranceCoverageCostItem = criteria.js(jsSelectors.replacementInsuranceCoverageCostItem, { multiple: true });
            var replacementInsuranceCoverageCostEmpty = criteria.js(jsSelectors.replacementInsuranceCoverageCostEmpty);
            var replacementInsuranceCoverageTotalCostValue = criteria.js(jsSelectors.replacementInsuranceCoverageTotalCostValue);
            var replacementInsuranceCoverageSubsidyAmountValue = criteria.js(jsSelectors.replacementInsuranceCoverageSubsidyAmountValue);

            // Get Select Helpers for selects where we're updating options and properties
            var insuranceCarrierSelectHelper = selectHelper.getHelper(insuranceCarrierSelect);
            var insuranceRateTierSelectHelper = selectHelper.getHelper(insuranceRateTierSelect);
            var terminatingInsuranceCoverageSelectHelper = selectHelper.getHelper(terminatingInsuranceCoverageSelect);
            var replacementInsuranceCoverageSelectHelper = selectHelper.getHelper(replacementInsuranceCoverageSelect);

            // show/hide terminating insurance coverage cost on hover
            terminatingInsuranceCoverageCostContainer.hoverIntent({
                handlerOver: function () {
                    terminatingInsuranceCoverageCostPanel.toggleClass(cssSelectors.visible, true);
                },
                handlerOut: function () {
                    terminatingInsuranceCoverageCostPanel.toggleClass(cssSelectors.visible, false);
                },
                hoverOutDelay: 400
            });

            // show/hide replacement insurance coverage cost on hover
            replacementInsuranceCoverageCostContainer.hoverIntent({
                handlerOver: function () {
                    replacementInsuranceCoverageCostPanel.toggleClass(cssSelectors.visible, true);
                },
                handlerOut: function () {
                    replacementInsuranceCoverageCostPanel.toggleClass(cssSelectors.visible, false);
                },
                hoverOutDelay: 400
            });

            // Register insuranceTypeSelect changed event
            insuranceTypeSelect.change(insuranceTypeChanged);

            // Register insuranceCarrierSelect changed event
            insuranceCarrierSelect.change(insuranceCarrierChanged);

            // Register insuranceRateTierSelect changed event
            insuranceRateTierSelect.change(insuranceRateTierChanged);

            // Register terminatingInsuranceCoverageSelect changed event
            terminatingInsuranceCoverageSelect.change(terminatingInsuranceCoverageChanged);

            // Register replacementInsuranceCoverageEffectiveDatePicker changed event
            replacementInsuranceCoverageEffectiveDatePicker.change(_.debounce(function () {
                replacementInsuranceCoverageEffectiveDateChanged();
            }, 500));

            // Register replacementInsuranceCoverageSelect changed event
            replacementInsuranceCoverageSelect.change(replacementInsuranceCoverageChanged);

            // Enable and disable fields
            enableDisableFields();

            // On insurance type change, handle population of associated insurance carriers
            function insuranceTypeChanged() {

                var insuranceTypeSpecified = insuranceTypeSelect.val() !== "";

                if (insuranceTypeSpecified) {

                    var selectedInsuranceTypeCd = insuranceTypeSelect.val();

                    // Populate carriers based on selected type
                    insuranceCarrierSelectHelper.loadOptionsFrom(backendUrls.getInsuranceCarriers, { insuranceType: selectedInsuranceTypeCd }, { withBlank: true });

                } else {

                    insuranceCarrierSelectHelper.clearOptions();
                }

                // Clear both terminating and replacement coverage options
                insuranceRateTierSelectHelper.clearOptions();
                terminatingInsuranceCoverageSelectHelper.clearOptions();
                replacementInsuranceCoverageSelectHelper.clearOptions();

                enableDisableFields();
            }

            // On insurance carrier change, handle population of associated insurance coverages
            function insuranceCarrierChanged() {

                var insuranceTypeSpecified = insuranceTypeSelect.val() !== "";
                var insuranceCarrierSpecified = insuranceCarrierSelect.val() !== "";

                if (insuranceTypeSpecified && insuranceCarrierSpecified) {

                    var selectedInsuranceTypeCd = insuranceTypeSelect.val();
                    var selectedInsuranceCarrierKey = insuranceCarrierSelect.val();

                    // Populate rate tiers based on selected type
                    insuranceRateTierSelectHelper.loadOptionsFrom(backendUrls.getInsuranceRateTiers, { insuranceType: selectedInsuranceTypeCd, insuranceCarrierKey: selectedInsuranceCarrierKey }, { withBlank: true });

                } else {
                    insuranceRateTierSelectHelper.clearOptions();
                }

                // attempt to populare replacement insurance coverages (dependent on carrier, terminating coverage and replacement insurance coverage effective date)
                terminatingInsuranceCoverageSelectHelper.clearOptions();
                populateReplacementInsuranceCoverages();

                enableDisableFields();
            }

            // On insurance rate tier change, handle population of associated insurance carriers
            function insuranceRateTierChanged() {

                var insuranceTypeSpecified = insuranceTypeSelect.val() !== "";
                var insuranceCarrierSpecified = insuranceCarrierSelect.val() !== "";
                var insuranceRateTierSpecified = insuranceRateTierSelect.val() !== "";

                if (insuranceTypeSpecified && insuranceCarrierSpecified && insuranceRateTierSpecified) {

                    var selectedInsuranceTypeCd = insuranceTypeSelect.val();
                    var selectedInsuranceCarrierKey = insuranceCarrierSelect.val();
                    var selectedInsuranceRateTierKey = insuranceRateTierSelect.val();

                    // Populate terminating insurance coverages based on selected carrier and type
                    terminatingInsuranceCoverageSelectHelper.loadOptionsFrom(backendUrls.getTerminatingInsuranceCoverages, { insuranceCarrierKey: selectedInsuranceCarrierKey, insuranceType: selectedInsuranceTypeCd, insuranceRateTierKey: selectedInsuranceRateTierKey }, { withBlank: true });

                } else {

                    terminatingInsuranceCoverageSelectHelper.clearOptions();
                }

                enableDisableFields();
            }

            // On terminating insurance coverage change, handle population of it's coverage cost
            function terminatingInsuranceCoverageChanged() {

                var terminatingInsuranceCoverageSpecified = terminatingInsuranceCoverageSelect.val() !== "";

                if (terminatingInsuranceCoverageSpecified) {

                    var selectedTerminatingInsuranceCoverageKey = terminatingInsuranceCoverageSelect.val();

                    $.get(backendUrls.getInsuranceCoverageCost, { insuranceCoverageKey: selectedTerminatingInsuranceCoverageKey })
                        .done(function (result) {
                            if (result) {
                                terminatingInsuranceCoverageTotalCostValue.text(result.totalCostAmount);
                                terminatingInsuranceCoverageSubsidyAmountValue.text(result.subsidyAmount);                      
                            }
                        });
                }

                // attempt to populare replacement insurance coverages (dependent on carrier, terminating coverage and replacement insurance coverage effective date)
                populateReplacementInsuranceCoverages();

                enableDisableFields();
            }

            // On replacement insurance coverage effective date change, handle population of replacement insurance coverages
            function replacementInsuranceCoverageEffectiveDateChanged() {

                // attempt to populare replacement insurance coverages (dependent on carrier, terminating coverage and replacement insurance coverage effective date)
                populateReplacementInsuranceCoverages();

                enableDisableFields();
            }

            // On replacement insurance coverage change, handle population of it's coverage cost
            function replacementInsuranceCoverageChanged() {

                var replacementInsuranceCoverageSpecified = replacementInsuranceCoverageSelect.val() !== "";

                if (replacementInsuranceCoverageSpecified) {

                    var selectedReplacementInsuranceCoverageKey = replacementInsuranceCoverageSelect.val();

                    $.get(backendUrls.getInsuranceCoverageCost, { insuranceCoverageKey: selectedReplacementInsuranceCoverageKey })
                        .done(function (result) {
                            if (result) {
                                replacementInsuranceCoverageTotalCostValue.text(result.totalCostAmount);
                                replacementInsuranceCoverageSubsidyAmountValue.text(result.subsidyAmount);
                            }
                        });
                }

                enableDisableFields();
            }

            // Handle population of replacement insurance coverages
            function populateReplacementInsuranceCoverages() {

                var insuranceTypeSpecified = insuranceTypeSelect.val() !== "";
                var insuranceCarrierSpecified = insuranceCarrierSelect.val() !== "";
                var insuranceRateTierSpecified = insuranceRateTierSelect.val() !== "";
                var replacementInsuranceCoverageEffectiveDateSpecified = replacementInsuranceCoverageEffectiveDatePicker.val() !== "";
                var terminatingInsuranceCoverageSpecified = terminatingInsuranceCoverageSelect.val() !== "";

                if (insuranceTypeSpecified && insuranceCarrierSpecified && insuranceRateTierSpecified && replacementInsuranceCoverageEffectiveDateSpecified) {

                    var selectedInsuranceTypeCd = insuranceTypeSelect.val();
                    var selectedInsuranceCarrierKey = insuranceCarrierSelect.val();
                    var selectedInsuranceRateTierKey = insuranceRateTierSelect.val();
                    var selectedReplacementInsuranceCoverageEffectiveDate = replacementInsuranceCoverageEffectiveDatePicker.val();

                    // set selectedTerminatingInsuranceCoverageKey if one is selected, otherwise leave it NULL
                    var selectedTerminatingInsuranceCoverageKey;
                    if (terminatingInsuranceCoverageSpecified) {
                        selectedTerminatingInsuranceCoverageKey = terminatingInsuranceCoverageSelect.val();
                    }

                    // Populate replacement insurance coverages based on selected type, carrier, replacement coverage effective date, and terminating coverage
                    replacementInsuranceCoverageSelectHelper.loadOptionsFrom(backendUrls.getReplacementInsuranceCoverages,
                        {
                            insuranceCarrierKey: selectedInsuranceCarrierKey,
                            insuranceType: selectedInsuranceTypeCd,
                            insuranceRateTierKey: selectedInsuranceRateTierKey,
                            insuranceCoverageEffectiveDate: selectedReplacementInsuranceCoverageEffectiveDate,
                            terminatingInsuranceCoverageKey: selectedTerminatingInsuranceCoverageKey
                        }, { withBlank: true }
                    );

                } else {

                    replacementInsuranceCoverageSelectHelper.clearOptions();
                }
            }

            // enable or disable carrier select based on whether or not a type is selected
            function enableDisableFields() {

                // enable/disable carrier select based on type selected
                var selectedInsuranceType = insuranceTypeSelect.val();
                insuranceCarrierSelectHelper.setDisabled(!selectedInsuranceType || selectedInsuranceType === "");

                // enable/disable rate tier select based on type and carrier selected
                var selectedInsuranceCarrier = insuranceCarrierSelect.val();
                insuranceRateTierSelectHelper.setDisabled(!selectedInsuranceCarrier || selectedInsuranceCarrier === "");

                // enable/disable terminating coverage select based on type and carrier and rate tier selected
                var selectedInsuranceRateTier = insuranceRateTierSelect.val();
                terminatingInsuranceCoverageSelectHelper.setDisabled(!selectedInsuranceRateTier || selectedInsuranceRateTier === "");

                // hide/show terminating coverage cost based on coverage being selected
                var selectedTerminatingInsuranceCoverage = terminatingInsuranceCoverageSelect.val();
                if (!selectedTerminatingInsuranceCoverage || selectedTerminatingInsuranceCoverage === "") {
                    terminatingInsuranceCoverageCostItem.hide();
                    terminatingInsuranceCoverageCostEmpty.show();
                }
                else {
                    terminatingInsuranceCoverageCostItem.show();
                    terminatingInsuranceCoverageCostEmpty.hide();
                }
                 
                // enable/disable replacement coverage select based on type, carrier and replacement coverage effective date being selected
                var selectedReplacementInsuranceCoverageEffectiveDate = replacementInsuranceCoverageEffectiveDatePicker.val();
                replacementInsuranceCoverageSelectHelper.setDisabled(!selectedInsuranceCarrier || selectedInsuranceCarrier === "" || !selectedInsuranceRateTier || selectedInsuranceRateTier === "" || selectedReplacementInsuranceCoverageEffectiveDate === "");

                // hide/show replacement coverage cost based on coverage being selected
                var selectedReplacementInsuranceCoverage = replacementInsuranceCoverageSelect.val();
                if (!selectedReplacementInsuranceCoverage || selectedReplacementInsuranceCoverage === "") {
                    replacementInsuranceCoverageCostItem.hide();
                    replacementInsuranceCoverageCostEmpty.show();
                }
                else {
                    replacementInsuranceCoverageCostItem.show();
                    replacementInsuranceCoverageCostEmpty.hide();
                }
            }
        }
    
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);